import React from 'react';
import { TbStarFilled, TbStarHalfFilled, TbStar } from 'react-icons/tb';

const RatingStars = ({ rating , color }) => {
    const stars = [];

    for (let i = 1; i <= 5; i++) {
        if (rating >= i) {
            // ستاره کامل
            stars.push(<TbStarFilled key={i} style={{ color }} />);
        } else if (rating >= i - 0.5) {
            // ستاره نصفه
            stars.push(<TbStarHalfFilled key={i} style={{ color }} />);
        } else {
            // ستاره خالی
            stars.push(<TbStar key={i} style={{ color }} />);
        }
    }

    return <div className="flex ltr">{stars}</div>;
};

export default RatingStars;
